export default [{
        name: '首页',
        path: '/',
        icon: 'ios-home-outline',
        authority: 'Manage Edit'
    },
    {
        name: '管理',
        icon: 'ios-paper-outline',
        authority: 'Manage Edit',
        children: [
            {
                name: '内容审核',
                path: '/manage/contentaudit',
                authority: 'Manage'
            }
        ]
    },
    {
        name: '设置',
        icon: 'ios-gear-outline',
        authority: 'Manage Edit',
        children: [{
                name: '账号信息',
                path: '/settings/account',
                authority: 'Manage Edit'
            },
            // {
            //     name: '基本信息',
            //     path: '/settings/basic',
            //     authority: 'Manage Edit'
            // }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/config/traineeEditor.js